/**
 * 专利选择服务接口
 * 负责管理自定义查询结果中专利的选择状态
 */
export interface PatentSelectionService {
    /**
     * 添加专利到选择列表
     * @param searchIndex - 搜索轮次索引
     * @param patentId - 专利ID
     * @returns 操作是否成功
     */
    addPatent(searchIndex: number, patentId: string): Promise<boolean>;

    /**
     * 从选择列表中移除专利
     * @param searchIndex - 搜索轮次索引
     * @param patentId - 专利ID
     * @returns 操作是否成功
     */
    removePatent(searchIndex: number, patentId: string): Promise<boolean>;
}

export const PatentSelectionService = Symbol('PatentSelectionService');
